'use client';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

// TODO find a better way to do an isMobile check in nexjs for SSR
// https://github.com/duskload/react-device-detect/issues/196
export const useTabletAndBelowMediaQuery = () => useMediaQuery({ query: '(max-width: 1023px)' });
export const useDesktopMediaQuery = () => useMediaQuery({ query: '(min-width: 1024px)' });

export const useMobileMediaQuery = () => useMediaQuery({ query: '(max-width: 767px)' });
export const useMdMediaQuery = () => useMediaQuery({ query: '(min-width: 768px) and (max-width: 1023px)' });
export const useLgMediaQuery = () => useMediaQuery({ query: '(min-width: 1024px) and (max-width: 1279px)' });
export const useXlMediaQuery = () => useMediaQuery({ query: '(min-width: 1280px)' });

export const useIsTabletBelow = () => {
    const isTabletBelowQuery = useTabletAndBelowMediaQuery();
    const [isTabletBelow, setIsTabletBelow] = useState<boolean>(false);
    useEffect(() => {
        setIsTabletBelow(isTabletBelowQuery);
    }, [isTabletBelowQuery]);
    return { isTabletBelow };
};
export const useIsDesktop = () => {
    const isDesktopQuery = useDesktopMediaQuery();
    const [isDesktop, setIsDesktop] = useState<boolean>(false);
    useEffect(() => {
        setIsDesktop(isDesktopQuery);
    }, [isDesktopQuery]);
    return { isDesktop };
};

// TODO find a better way to do an isMobile check in nexjs for SSR
// https://github.com/duskload/react-device-detect/issues/196
export const useIsMobile = () => {
    const isMobileQuery = useMobileMediaQuery();
    const [isMobile, setIsMobile] = useState<boolean>(false);
    useEffect(() => {
        setIsMobile(isMobileQuery);
    }, [isMobileQuery]);
    return { isMobile };
};

export const useIsMd = () => {
    const isMdQuery = useMdMediaQuery();
    const [isMd, setIsMd] = useState<boolean>(false);
    useEffect(() => {
        setIsMd(isMdQuery);
    }, [isMdQuery]);
    return { isMd };
};
export const useIsLg = () => {
    const isLgQuery = useLgMediaQuery();
    const [isLg, setIsLg] = useState<boolean>(false);
    useEffect(() => {
        setIsLg(isLgQuery);
    }, [isLgQuery]);
    return { isLg };
};
export const useIsXl = () => {
    const isXlQuery = useXlMediaQuery();
    const [isXl, setIsXl] = useState<boolean>(false);
    useEffect(() => {
        setIsXl(isXlQuery);
    }, [isXlQuery]);
    return { isXl };
};

export const useBreakpoint = () => {
    const { isMobile } = useIsMobile();
    const { isMd } = useIsMd();
    const { isLg } = useIsLg();
    const { isXl } = useIsXl();
    const { isTabletBelow } = useIsTabletBelow();
    const { isDesktop } = useIsDesktop();
    return {
        isMobile,
        isMd,
        isLg,
        isXl,
        isTabletBelow,
        isDesktop,
    };
};
